<div class="c-staticNotification">
  <p class="c-staticNotification__title">{{title | translate}}</p>
</div>
